var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
var StyledDialog = styled(Dialog)(function () {
  return {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        minWidth: '32rem'
      }
    }
  };
});
var StyledDialogIcon = styled(FontAwesomeIcon)(function (_a) {
  var theme = _a.theme;
  return {
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.warning.main
  };
});
var StyledTitle = styled(Typography)(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    fontSize: theme.typography.h1.fontSize
  };
});
export var LockBaselineDialog = function (_a) {
  var open = _a.open,
    onClose = _a.onClose,
    onConfirm = _a.onConfirm;
  var t = useTranslation(['translation', 'orgConfig']).t;
  return _jsxs(StyledDialog, __assign({
    open: open,
    onClose: onClose
  }, {
    children: [_jsx(DialogTitle, {
      children: _jsxs(Stack, __assign({
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, {
        children: [_jsx(StyledDialogIcon, {
          icon: faTriangleExclamation
        }), _jsx(StyledTitle, {
          children: t('action.lockBaselineTitle', {
            defaultValue: 'Lock Baseline Plan?'
          })
        })]
      }))
    }), _jsx(DialogContent, {
      children: _jsx(DialogContentText, __assign({
        component: "div",
        sx: {
          mb: 2
        }
      }, {
        children: t('action.lockBaselineDescription', {
          defaultValue: 'Locking this baseline plan commits its calculated required headcount against the organization seat reservations.'
        })
      }))
    }), _jsxs(DialogActions, __assign({
      sx: {
        justifyContent: 'space-between'
      }
    }, {
      children: [_jsx(Button, __assign({
        variant: "outlined",
        onClick: onClose
      }, {
        children: t('action.cancel', {
          defaultValue: 'Cancel'
        })
      })), _jsx(Button, __assign({
        variant: "contained",
        onClick: onConfirm
      }, {
        children: t('action.continueToLock', {
          defaultValue: 'Continue to Lock'
        })
      }))]
    }))]
  }));
};